<div class="agent-info-container">
  <div class="agent-details">
    <div class="form-row">
      <label for="agentName">{{'Agent Name' | translate}}:</label>
      <input id="agentName" type="text" [value]="agentDetails?.name || '-'" disabled />
    </div>
    <div class="form-row">
      <label for="hazardCategory">{{'Hazard Category' | translate}}:</label>
      <input id="hazardCategory" type="text"
        [value]="hazardCategoryLabelKey ? (hazardCategoryLabelKey | translate) : '-'" disabled />
      </div>
      <div class="form-row">
        <label for="healthAdvisory">{{'Health Advisory' | translate}}:</label>
        <input id="healthAdvisory" type="text" [value]="agentDetails?.healthAdvisory || '-'" disabled />
      </div>
      <div class="form-row">
        <label for="recommendations">{{'Specific Recommendations' | translate}}:</label>
        <input id="recommendations" type="text" [value]="agentDetails?.specificRecommendations || '-'" disabled />
      </div>
      <div class="form-row">
        <label for="jurisdictions">{{'Associated Jurisdictions' | translate}}:</label>
        <input id="jurisdictions" type="text" value="-" disabled />
      </div>
    </div>
    <div class="action-buttons">
      <button class="btn" *objectHasPermission="permissionObject; action: createAction" (click)="openAgentJurisdictionDialog()">{{'Add' | translate}}</button>
    </div>
  </div>

  <mat-tab-group [mat-stretch-tabs]="false" class="sidebar-tabs" (selectedTabChange)="onTabChange($event)">
    <mat-tab label="{{ 'Associated Jurisdictions' | translate }}">
      <div class="custom-theme-table mt-3">
        <div class="custom-scrollbar table-responsive outer-bordered-table">
          <table mat-table class="table table-striped" [dataSource]="dataSource" matSort matSortDisableClear>

            <tr class="mat-row" *matNoDataRow [ngClass]="{'loading-row':isLoading}">
              <td class="mat-cell text-center" [attr.colspan]="displayedColumns.length">
                @if (isLoading) {
                  <ng-container class="loader-container">
                    <app-rings-loader class="bg-transparent"></app-rings-loader>
                  </ng-container>
                } @else {
                  {{'No data matching the filter' | translate}}
                }
              </td>
            </tr>

            <ng-container matColumnDef="jurisdictionName">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'Jurisdictions Name' | translate}}</th>
              <td mat-cell *matCellDef="let element">{{ element.jurisdictionName ?? '-'}}</td>
            </ng-container>

            <ng-container matColumnDef="al">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'Action Level' | translate}}</th>
              <td mat-cell *matCellDef="let element">{{ element.al ?? '-'}}</td>
            </ng-container>

            <ng-container matColumnDef="oel">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'OEL' | translate}}</th>
              <td mat-cell *matCellDef="let element">
                @if (element.oelValue === null || element.oelValue === undefined) {
                  <span class="material-icons warning-icon" [matTooltip]="'No OEL established' | translate">warning_amber</span>
                }
                {{ element.oelValue | nullDisplay }}
              </td>
            </ng-container>

            <ng-container matColumnDef="oelTypeName">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'OEL Type' | translate }}</th>
              <td mat-cell *matCellDef="let element">{{ element?.oelTypeName ?? '-' }}</td>
            </ng-container>

            <ng-container matColumnDef="ceilingLimit">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'Ceiling Limit' | translate}}</th>
              <td mat-cell *matCellDef="let element">{{ element.ceilingLimit ?? '-'}}</td>
            </ng-container>

            <ng-container matColumnDef="stel">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'STEL' | translate}}</th>
              <td mat-cell *matCellDef="let element">{{ element.stel ?? '-'}}</td>
            </ng-container>

            <ng-container matColumnDef="exchangeRate">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'Exchange Rate' | translate}}</th>
              <td mat-cell *matCellDef="let element">{{ element.exchangeRate ?? '-'}}</td>
            </ng-container>

            <ng-container matColumnDef="threshold">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'Threshold' | translate}}</th>
              <td mat-cell *matCellDef="let element">{{ element.threshold ?? '-'}}</td>
            </ng-container>

            <ng-container matColumnDef="noiseFrequencyRating">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'Noise Freq Rating' | translate}}</th>
              <td mat-cell *matCellDef="let element">{{ element.noiseFrequencyRating != null ?
              (noiseFrequencyRatingEnum[element.noiseFrequencyRating] | translate) : '-'}}</td>
            </ng-container>

            <ng-container matColumnDef="noiseSpeed">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'Noise Speed' | translate}}</th>
              <td mat-cell *matCellDef="let element">{{ element.noiseSpeed != null ? ((noiseSpeedEnum[element.noiseSpeed] | translate) || '-') : '-'}}</td>
            </ng-container>

            <ng-container matColumnDef="oelCorrectionMethod">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'OEL Correction Method' | translate}}</th>
              <td mat-cell *matCellDef="let element">
                {{ element.oelCorrectionMethod != null ? (oelCorrectionMethodEnum[element.oelCorrectionMethod]|
              translate) :'-' }}</td>
            </ng-container>

            <ng-container matColumnDef="twaCorrectionMethod">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'TWA Correction Method' | translate}}</th>
              <td mat-cell *matCellDef="let element">
                {{ element.twaCorrectionMethod != null ? (twaCorrectionMethodEnum[element.twaCorrectionMethod]|
              translate) : '-' }}</td>
            </ng-container>

            <ng-container matColumnDef="effectivePeriod">
              <th mat-header-cell *matHeaderCellDef>{{'Effective Period' | translate}}</th>
              <td mat-cell *matCellDef="let element">{{ element.effectivePeriodDisplay ?? '-' }}</td>
            </ng-container>

            <ng-container matColumnDef="status">
              <th mat-header-cell *matHeaderCellDef>{{'Status' | translate}}</th>
              <td mat-cell *matCellDef="let element">
                <span class="version-status-badge" [ngClass]="element.statusClass">{{ element.statusLabel | translate }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef>{{'Actions' | translate}}</th>
              <td mat-cell *matCellDef="let element" class="text-align-right">
                @if (!element.isHistorical) {
                  <span class="material-icons edit cursor-pointer material-grey-icon"
                    *objectHasPermission="permissionObject; action: updateAction"
                    [matTooltip]="'Edit' | translate"
                  (click)="openAgentJurisdictionDialog(element.id)">edit</span>
                }
                @if (element.isHistorical) {
                  <span class="material-icons view cursor-pointer material-grey-icon"
                    [matTooltip]="'View' | translate"
                  (click)="openAgentJurisdictionDialog(element.id, true)">visibility</span>
                }
                @if (!element.isHistorical) {
                  <span class="material-icons add-version cursor-pointer material-grey-icon"
                    *objectHasPermission="permissionObject; action: createAction"
                    [matTooltip]="'New Version' | translate"
                  (click)="openNewVersionDialog(element.id)">library_add</span>
                }
                <span class="material-icons version-history cursor-pointer material-grey-icon"
                  [matTooltip]="'Version History' | translate"
                (click)="openVersionHistory(element.id)">history</span>
                @if (!element.isHistorical) {
                  <span class="material-icons delete cursor-pointer material-grey-icon"
                  *objectHasPermission="permissionObject; action: deleteAction"
                  (click)="openAgentJurisdictionDeleteDialog(element.id)">delete</span>
                }
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; let even = even; columns: displayedColumns;" [class.even-row]="even" [class.historical-version-row]="row.isHistorical"> </tr>
          </table>
        </div>
      </div>
    </mat-tab>

    <mat-tab label="{{ 'Organization Level' | translate }}">
      <div class="custom-theme-table mt-3">
        <div class="custom-scrollbar table-responsive outer-bordered-table">
          <table mat-table class="table table-striped" [dataSource]="associationsDataSource">

            <tr class="mat-row" *matNoDataRow>
              <td class="mat-cell text-center" [attr.colspan]="displayedAssociatedColumns.length">
                {{'No associated organization levels' | translate}}
              </td>
            </tr>

            <ng-container matColumnDef="organizationLevelName">
              <th class="left-aligned" mat-header-cell *matHeaderCellDef>{{'Organization Level Name' | translate}}</th>
              <td class="left-aligned" mat-cell *matCellDef="let element">{{ element.organizationLevelName ?? '-' }}</td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedAssociatedColumns"></tr>
            <tr mat-row *matRowDef="let row; let even = even; columns: displayedAssociatedColumns;" [class.even-row]="even"> </tr>
          </table>
        </div>
      </div>
    </mat-tab>

    <mat-tab label="{{ 'Agent History' | translate }}">
      <div class="custom-theme-table mt-3">
        <div class="custom-scrollbar table-responsive outer-bordered-table">
          <table mat-table class="table table-striped" [dataSource]="historyDataSource">
            <tr class="mat-row" *matNoDataRow [ngClass]="{ 'loading-row': isHistoryLoading }">
              <td class="mat-cell text-center" [attr.colspan]="historyDisplayedColumns.length">
                @if (isHistoryLoading) {
                  <app-rings-loader class="bg-transparent"></app-rings-loader>
                } @else {
                  {{ 'No data matching the filter' | translate }}
                }
              </td>
            </tr>

            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef>{{ 'Name' | translate }}</th>
              <td mat-cell *matCellDef="let history" [ngClass]="{ 'highlight': $safeNavigationMigration(history.changedFieldSet?.has('Name')) }"><span>{{ history?.name || '-' }}</span></td>
            </ng-container>

            <ng-container matColumnDef="casId">
              <th mat-header-cell *matHeaderCellDef>{{ 'CAS #' | translate }}</th>
              <td mat-cell *matCellDef="let history" [ngClass]="{ 'highlight': $safeNavigationMigration(history.changedFieldSet?.has('CasId')) }"><span>{{ history?.casId || '-' }}</span></td>
            </ng-container>

            <ng-container matColumnDef="agentForm">
              <th mat-header-cell *matHeaderCellDef>{{ 'Agent Fraction' | translate }}</th>
              <td mat-cell *matCellDef="let history" [ngClass]="{ 'highlight': $safeNavigationMigration(history.changedFieldSet?.has('AgentForm')) }"><span>{{ history?.agentForm || '-' }}</span></td>
            </ng-container>

            <ng-container matColumnDef="agentType">
              <th mat-header-cell *matHeaderCellDef>{{ 'Agent Type' | translate }}</th>
              <td mat-cell *matCellDef="let history" [ngClass]="{ 'highlight': $safeNavigationMigration(history.changedFieldSet?.has('AgentType')) }"><span>{{ history.agentTypeDisplay | translate }}</span></td>
            </ng-container>

            <ng-container matColumnDef="healthAdvisory">
              <th mat-header-cell *matHeaderCellDef>{{ 'Health Advisory' | translate }}</th>
              <td mat-cell *matCellDef="let history" [ngClass]="{ 'highlight': $safeNavigationMigration(history.changedFieldSet?.has('HealthAdvisory')) }"><span>{{ history?.healthAdvisory || '-' }}</span></td>
            </ng-container>

            <ng-container matColumnDef="consequenceRating">
              <th mat-header-cell *matHeaderCellDef>{{ 'Consequence Rating' | translate }}</th>
              <td mat-cell *matCellDef="let history" [ngClass]="{ 'highlight': $safeNavigationMigration(history.changedFieldSet?.has('ConsequenceRating')) }"><span>{{ history?.consequenceRating ?? '-' }}</span></td>
            </ng-container>

            <ng-container matColumnDef="organizationLevelName">
              <th mat-header-cell *matHeaderCellDef>{{ 'Visibility' | translate }}</th>
              <td mat-cell *matCellDef="let history" [ngClass]="{ 'highlight': history.changedFieldSet?.has('OrganizationLevelName') || history.changedFieldSet?.has('OrganizationLevelId') }"><span>{{ history?.organizationLevelName || '-' }}</span></td>
            </ng-container>

            <ng-container matColumnDef="dateUpdated">
              <th mat-header-cell *matHeaderCellDef>{{ 'Updated Date' | translate }}</th>
              <td mat-cell *matCellDef="let history" [ngClass]="{ 'highlight': $safeNavigationMigration(history.changedFieldSet?.has('DateUpdated')) }"><span>{{ history.dateUpdatedDisplay }}</span></td>
            </ng-container>

            <ng-container matColumnDef="updatedByUserName">
              <th mat-header-cell *matHeaderCellDef>{{ 'Updated By' | translate }}</th>
              <td mat-cell *matCellDef="let history" [ngClass]="{ 'highlight': history.changedFieldSet?.has('UpdatedByUserName') || history.changedFieldSet?.has('UpdatedByUserId') }"><span>{{ history?.updatedByUserName || '-' }}</span></td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="historyDisplayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: historyDisplayedColumns"></tr>
          </table>
        </div>
      </div>
    </mat-tab>
  </mat-tab-group>
